export default __webpack_public_path__ + "static/media/Emotions_00.ff94db02.png";